import React from 'react'

function PersonFormIcon() {
  return (
    <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.579 1.28C9.75 1.44 8.2 2.632 7.54 4.384c-.358.951-.358 2.281 0 3.232a4.799 4.799 0 0 0 2.836 2.841c.964.363 2.284.363 3.248 0a4.799 4.799 0 0 0 2.836-2.841c.359-.955.358-2.28-.003-3.24-.762-2.028-2.741-3.284-4.878-3.096m1.401 1.614c.528.174.874.392 1.304.822.428.427.644.769.824 1.304.101.296.109.369.109.98s-.008.684-.109.98c-.18.535-.396.877-.824 1.304-.427.428-.769.644-1.304.824-.296.101-.369.109-.98.109s-.684-.008-.98-.109c-.535-.18-.877-.396-1.304-.824-.428-.427-.644-.769-.824-1.304-.101-.296-.109-.369-.109-.98s.008-.684.109-.98c.18-.535.396-.877.824-1.304.717-.717 1.35-.966 2.384-.941.472.012.61.031.88.119m-1.773 9.388c-2.759.136-5.265 1.065-6.689 2.478-.607.603-.991 1.245-1.167 1.952-.074.296-.086.455-.083 1.068.008 1.642.238 2.414.943 3.163 1.193 1.269 3.455 1.788 7.789 1.788s6.596-.519 7.789-1.788c.705-.749.933-1.514.942-3.161.004-.615-.008-.773-.082-1.07-.53-2.132-3.117-3.822-6.606-4.313-.45-.063-2.03-.174-2.183-.152-.022.003-.316.019-.653.035m2.533 1.576c2.054.299 3.739 1.009 4.7 1.981.383.388.603.732.727 1.136.077.252.082.339.062 1.08-.024.885-.066 1.119-.275 1.51-.4.751-1.442 1.221-3.274 1.475-1.125.156-1.61.18-3.68.18-2.07 0-2.555-.024-3.68-.18-1.832-.254-2.874-.724-3.274-1.475-.209-.391-.251-.625-.275-1.51-.02-.741-.015-.828.062-1.08.124-.404.344-.748.727-1.136 1.08-1.093 2.969-1.814 5.38-2.055.397-.039 2.38.013 2.8.074"
      fillRule="evenodd"
      fill="#ffffff"
    />
  </svg>
  )
}

export default PersonFormIcon